/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentEditorsDiscountTypesQueryResponse,
  GetApiV1IndividualpaymentEditorsDiscountTypesQueryParams,
  GetApiV1IndividualpaymentEditorsDiscountTypes401,
  GetApiV1IndividualpaymentEditorsDiscountTypes500,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentEditorsDiscountTypes.ts";

function getGetApiV1IndividualpaymentEditorsDiscountTypesUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/editors/discount-types` as const,
  };
  return res;
}

/**
 * @description Retorna os tipos ativos com descrição por idioma e o indicador de empresa associada obrigatória. Migrado do legado RegistryAsync/GetDiscountTypes. **(Requer Authorization para autenticação)**
 * @summary Tipos de desconto ativos para o editor do plano (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/editors/discount-types}
 */
export async function getApiV1IndividualpaymentEditorsDiscountTypes(
  params?: GetApiV1IndividualpaymentEditorsDiscountTypesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentEditorsDiscountTypesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentEditorsDiscountTypes401
      | GetApiV1IndividualpaymentEditorsDiscountTypes500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentEditorsDiscountTypesUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
